import React from "react";

export default function SheetFrame({
  paper,
  pxPerMm = 3,
  marginMm = 10,
  titleBlockWidthMm = 170,
  titleBlockHeightMm = 45,
}) {
  const widthMm = Number(paper?.widthMm || 420);
  const heightMm = Number(paper?.heightMm || 297);

  const outer = {
    x: marginMm,
    y: marginMm,
    width: widthMm - marginMm * 2,
    height: heightMm - marginMm * 2,
  };

  const title = {
    x: widthMm - marginMm - titleBlockWidthMm,
    y: heightMm - marginMm - titleBlockHeightMm,
    width: titleBlockWidthMm,
    height: titleBlockHeightMm,
  };

  return (
    <svg
      className="absolute inset-0 pointer-events-none"
      width={widthMm * pxPerMm}
      height={heightMm * pxPerMm}
      viewBox={`0 0 ${widthMm} ${heightMm}`}
      style={{
        zIndex: 5,
      }}
    >
      {/* paper outer border */}
      <rect
        x={0}
        y={0}
        width={widthMm}
        height={heightMm}
        fill="white"
        stroke="#0f172a"
        strokeWidth={0.35}
      />

      {/* drawing margin frame */}
      <rect
        x={outer.x}
        y={outer.y}
        width={outer.width}
        height={outer.height}
        fill="none"
        stroke="#0f172a"
        strokeWidth={0.5}
      />

      {/* title block outer frame */}
      <rect
        x={title.x}
        y={title.y}
        width={title.width}
        height={title.height}
        fill="none"
        stroke="#0f172a"
        strokeWidth={0.5}
      />

      {/* title block columns/rows */}
      <line
        x1={title.x}
        y1={title.y + 12}
        x2={title.x + title.width}
        y2={title.y + 12}
        stroke="#0f172a"
        strokeWidth={0.35}
      />

      <line
        x1={title.x}
        y1={title.y + 24}
        x2={title.x + title.width}
        y2={title.y + 24}
        stroke="#0f172a"
        strokeWidth={0.35}
      />

      <line
        x1={title.x}
        y1={title.y + 34}
        x2={title.x + title.width}
        y2={title.y + 34}
        stroke="#0f172a"
        strokeWidth={0.35}
      />

      <line
        x1={title.x + 105}
        y1={title.y}
        x2={title.x + 105}
        y2={title.y + title.height}
        stroke="#0f172a"
        strokeWidth={0.35}
      />

      <line
        x1={title.x + 135}
        y1={title.y + 24}
        x2={title.x + 135}
        y2={title.y + title.height}
        stroke="#0f172a"
        strokeWidth={0.35}
      />

      {/* optional folding / printable safe area label */}
      <text
        x={marginMm}
        y={heightMm - 3}
        fontSize={3}
        fill="#64748b"
      >
        A3 Landscape · Modular Objects Documentation
      </text>
    </svg>
  );
}